import { createGlobalStyle } from "styled-components";
import sass from "../../../components/controllers/shared/styled/sass";

const { prussianBlue, navyBlue, admiralBlue } = sass.variables.color;

const Style = createGlobalStyle`
.customize.navbar-principal-primary .navbar-default, .progress-bar {
	background-color: ${prussianBlue};
}

.btn-primary.btn-primary-alt {
	background: ${navyBlue};
}

.btn-primary.btn-primary-alt:hover,  .btn-primary.btn-primary-alt.hover,
.btn-primary.btn-primary-alt:active, .btn-primary.btn-primary-alt.active,
.btn-primary.btn-primary-alt:focus, .btn-primary.btn-primary-alt:active:focus
{
	background: ${admiralBlue};
}
`;

export default Style;
